import React from 'react'

import { Button, Title } from '@acorns/web-components'
import styled from 'styled-components'

import { routes } from 'router/routes'
import { style } from 'theme'
import { PAGE_NOT_FOUND } from 'utils/testing/testIDs'

import acorns404 from './acorns404.svg'

type Props = {
  message?: string
}

const Container = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
`

const StyledTitle = styled(Title)`
  margin-bottom: 20px;
  text-align: center;
  @media (max-width: ${style((theme) => `${theme.breakpoints.md}px`)}) {
    width: 500px;
    margin: auto;
    margin-bottom: 20px;
  }
  @media (max-width: 500px) {
    width: 320px;
    margin: auto;
    margin-bottom: 20px;
  }
`

const BackToHomeButton = styled(Button)`
  width: 335px;
  height: 44px;
  margin: auto;
  @media (min-width: 320px) and (max-width: 374px) {
    width: 300px;
  }
`

const StyledImage = styled.img`
  margin-bottom: 40px;
  @media (max-width: ${style((theme) => `${theme.breakpoints.sm}px`)}) {
    width: 280px;
    margin: auto;
    margin-bottom: 40px;
  }
`

const PageNotFound = (props: Props) => {
  const handleNavigate = () => {
    window.location.href = routes.present
  }
  return (
    <Container data-testid={PAGE_NOT_FOUND}>
      <StyledImage src={acorns404} alt="acorns404" />
      <StyledTitle bold>
        {props.message ?? "It looks like the page couldn't be found."}
      </StyledTitle>
      <BackToHomeButton onPress={handleNavigate}>Back to home</BackToHomeButton>
    </Container>
  )
}

export default PageNotFound
